const firebase = require("@/firebaseConfig.js");

const model = {
  name: null,
  client: null,
  skills: [],
  description: null,
  preferences: [],
  budget: null,
  created: null,
  timeline: null,
  providers: {
    applied: [],
    accepted: [],
    approved: [],
    hidden: [],
    rejected: [],
    invited: []
  }
};

const fields = [
  {
    path: "name",
    type: "text",
    label: "Project name"
  },
  {
    path: "client",
    type: "single_select",
    label: "Client",
    reference: "clients",
    options: firebase.db.collection("users").where("type", "==", "client"),
    text_field: "company.name"
  },
  {
    path: "description",
    type: "text",
    label: "Project description"
  },
  {
    path: "verified",
    type: "boolean",
    label: "Verified"
  },
  {
    path: "skills",
    type: "multi_select",
    label: "Skills",
    reference: "skills",
    options: firebase.db.collection("skills")
  },
  {
    path: "preferences",
    type: "multi_select",
    label: "Preferences",
    reference: "preferences",
    options: firebase.db.collection("preferences")
  },
  {
    path: "goals",
    type: "multi_select",
    label: "Goals",
    reference: "goals",
    options: firebase.db.collection("goals")
  },
  {
    path: "timeline",
    type: "single_select",
    label: "Due date",
    options: ["1-2 months", "3-6 months", "Over 6 months"]
  },
  {
    path: "budget",
    type: "number",
    label: "Budget ($)"
  }
];

const tableFields = [
  {
    key: "name",
    label: "Name",
    sortable: true
  },
  {
    key: "client.company.name",
    label: "Client",
    sortable: true
  }
];

const info = {
  id: "projects",
  db: "projects",
  name: "Projects",
  single: "Project",
  fields: tableFields
};

export {model, fields, info};
